import { __awaiter, __generator } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import { onMounted } from 'vue';
import { useStore } from 'vuex';
import NavBar from '@/components/NavBar.vue';
import { userApi } from '@/api/user';
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup: function (__props) {
        var _this = this;
        var store = useStore();
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var res, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!store.getters.isAuthenticated) return [3 /*break*/, 4];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, userApi.getUserInfo()];
                    case 2:
                        res = _b.sent();
                        if (res.code === 200 && res.data) {
                            store.commit('SET_USER_INFO', res.data);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); });
        return function (_ctx, _cache) {
            var _component_router_view = _resolveComponent("router-view");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (!_ctx.$route.meta.hideNavbar)
                    ? (_openBlock(), _createBlock(NavBar, { key: 0 }))
                    : _createCommentVNode("", true),
                _createVNode(_component_router_view)
            ], 64));
        };
    }
});
